import { boundApiRequest, request } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/notify/');


export async function search(reqt) {
    const { result } = await doRequest('search', reqt, {});

    return result;
}

export async function unreadCount() {
    const { result } = await doRequest('count', {}, {});

    return result;
}

export async function read(data) {
    const { result } = await doRequest('read', data, {});

    return result;
}

export async function readAll() {
    const { result } = await doRequest('read/all', {}, {});

    return result;
}
